<template>
  <div>
    <div style="padding: 150px">
      <a-form-item>
        <a-button type="primary" @click="addCase">
          新增项目
        </a-button>
      </a-form-item>
      <a-form-item>
        <a-table :columns="columns" :dataSource="data" :rowKey="record=>record.id">
      <span slot="actions" slot-scope="text,record">
        <a @click="clickEdit(record)">
          编辑
        </a>
        <a-divider type="vertical" />
        <a @click="clickDelete(record)">
          删除
        </a>
      </span>
        </a-table>
      </a-form-item>

      <a-modal :visible="modalShow" :title="modalTitle" @cancel="handleCancel" @ok="handleSubmit">
        <a-col>
          <a-form-item label="项目名称" :required="true">
            <a-input v-model="caseTitle"></a-input>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item label="项目地址" :required="true">
            <a-input v-model="caseLink"></a-input>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item label="项目排序值" :required="true">
            <a-input v-model="caseSort"></a-input>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item label="上传图片">
            <a-upload name="avatar" accept=".png,.jpg,.jpeg"
                      listType="picture-card" :showUploadList="false" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      :beforeUpload="beforeUpload"
                      @change="handleChange">
              <img v-if="caseImg" :src="caseImg" alt="avatar" style="height: 100px;width: 100px"/>
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item label="项目描述" :required="true">
            <a-textarea v-model="caseDescription"></a-textarea>
          </a-form-item>
        </a-col>
      </a-modal>
    </div>

  </div>
</template>

<script>
  import ACol from "ant-design-vue/es/grid/Col";
  const columns = [
    {
      title: '项目名称',
      dataIndex: 'title',
      scopedSlots: { customRender: 'name' },
    },{
      title:'项目描述',
      dataIndex:'description'
   },{
      title:'操作',
      dataIndex:'actions',
      scopedSlots: {customRender: 'actions'}
    }
  ];
  import AFormItem from "ant-design-vue/es/form/FormItem";
  import ATextarea from "ant-design-vue/es/input/TextArea";
    export default {
        name: "Setting",
      components: {ATextarea, ACol, AFormItem},
      data (){
          return {
            data:[{
              id:'1',
              title:'养老系统',
              description:'养老系统介绍介绍'
            },
              {
                id:'2',
                title:'养老系统',
                description:'养老系统介绍介绍'
              }
            ],
            columns,
            modalShow:false,
            modalTitle:'',
            caseTitle:'',
            caseDescription:'',
            caseLink:'',
            caseImg:'',
            caseSort:'',
            loading:false,
            caseId:''
          }
      },
      created (){
          this.getCaseInfo();
      },
      methods: {
          getCaseInfo(){
            let url = '';
            this.axios.get(url).then((res)=>{
              console.log(res)
            })
          },
          addCase(){
            this.modalShow = true
            this.modalTitle = '新增项目';
            this.caseImg = '';
            this.caseDescription = '';
            this.caseLink = '';
            this.caseTitle = '';
            this.caseSort = '';
            this.caseId = '';
          },
          clickEdit(record){
            this.modalShow = true;
            this.modalTitle = '编辑项目信息';
            this.caseImg = record.imgUrl;
            this.caseDescription = record.description;
            this.caseLink = record.link;
            this.caseTitle = record.title;
            this.caseSort = record.sort;
          },
          clickDelete(record){
            console.log(record.id)
          },
          handleCancel (){
            this.modalShow = false
          },
          handleChange(info) {
            console.log(info)
            if (info.file.status === 'uploading') {
              this.loading = true;
              return;
            }
            if (info.file.status === 'done') {
                this.caseImg = info.file.response.url;
                this.loading = false;
            }
          },
          beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
              this.$message.error('Image must smaller than 2MB!');
            }
            return isLt2M;
          },
          handleSubmit (){
            let url = '',
              params = {
              title:this.caseTitle,
              description:this.caseDescription,
              link:this.caseLink,
              imgUrl:this.caseImg,
              sort:this.caseSort
            };
            if (this.caseId){
              params.id = this.caseId
            }
            console.log('ok')
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Setting.vue